import React from "react";
import { PanelSection } from "../../../../../ui/PanelShell";
import { useMapEditorActions } from "../../../../contexts/MapEditorContext";
import { DragNumberInput } from "../../../controls/ScrollDragNumberInput";
import { ShapeSectionOptions } from "../ShapePanel";

export const CommonSizePanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditorActions();
  const shape = shapes[0];

  const handleWidthChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { width: Number.parseInt(String(value), 10) });
    });
  };

  const handleHeightChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, { height: Number.parseInt(String(value), 10) });
    });
  };

  return (
    <PanelSection label="Size">
      <div className="grid grid-cols-2 gap-1.5">
        <div className="flex flex-col gap-1">
          <span className="text-neutral-600 text-xs">Width</span>
          <DragNumberInput
            size={"sm"}
            value={shape.width}
            onChange={handleWidthChangeValue}
          />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-neutral-600 text-xs">Height</span>
          <DragNumberInput
            size={"sm"}
            value={shape.height}
            onChange={handleHeightChangeValue}
          />
        </div>
      </div>
    </PanelSection>
  );
};
